module.exports = __webpack_public_path__ + "img/hair-business-story-casey.a1f1cf5d.png";